// Types of action for requesting team leaderboard
export const REQUEST_TEAM_LEADERBOARD = 'REQUEST_TEAM_LEADERBOARD';
export const REQUEST_TEAM_LEADERBOARD_PENDING = 'REQUEST_TEAM_LEADERBOARD_PENDING';
export const REQUEST_TEAM_LEADERBOARD_SUCCESS = 'REQUEST_TEAM_LEADERBOARD_SUCCESS';
export const REQUEST_TEAM_LEADERBOARD_ERROR = 'REQUEST_TEAM_LEADERBOARD_ERROR';
// Types of action for requesting team leaderboard as CSV
export const REQUEST_TEAM_LEADERBOARD_AS_CSV = 'REQUEST_TEAM_LEADERBOARD_AS_CSV';
// Add teams to state
export const ADD_TEAM_LEADERBOARD = 'ADD_TEAM_LEADERBOARD';